exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contentful-detail-project-slug-title-js": () => import("./../../../src/pages/{contentfulDetailProject.slug__title}.js" /* webpackChunkName: "component---src-pages-contentful-detail-project-slug-title-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

